import styled from "styled-components";

export const ImageSettedDiv = styled.div`
	background-image: url("${({ imageSource }) => imageSource}");
	background-repeat: no-repeat;
	background-size: cover;
`;
